'use client';

import { Link, ReviewRating as BaseReviewRating } from '@coolblue-development/freddy';
import { HideSystemProps } from '@coolblue-development/freddy/theme';
import readMediaGalleryReviewsTrigger from '@coolblue-development/ga4-events/triggers/ImageGallery/readReviewsTrigger';
import showMediaGalleryReviewsTrigger from '@coolblue-development/ga4-events/triggers/ImageGallery/showReviewsTrigger';
import readOrderBlockReviewsTrigger from '@coolblue-development/ga4-events/triggers/OrderBlock/readReviewsTrigger';
import showOrderBlockReviewsTrigger from '@coolblue-development/ga4-events/triggers/OrderBlock/showReviewsTrigger';
import { TrackImmediate, useAnalytics } from '@coolblue-development/next-analytics/client';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { useRequestContext } from '@coolblue-development/next-request-context/client';
import type { Product } from '@features/product/typings';
import { MainProduct } from '@features/second-chance/typings';
import { scrollToTarget } from '@utils/utils';

type Props = HideSystemProps & {
  product: Product | MainProduct;
  reviewsSectionId: string;
  isInMediaGallery?: boolean;
};

export const EmphasizedReviewRating = ({
  product,
  reviewsSectionId,
  isInMediaGallery = false,
  ...rest
}: Props) => {
  const reviewRatingTranslations = useFreddyTranslations('reviewRating');
  const { language } = useRequestContext();
  const { trackEvent } = useAnalytics();

  return (
    <BaseReviewRating
      {...rest}
      sx={{ '> a': { display: 'contents' } }}
      translations={reviewRatingTranslations}
      value={product.reviewMetaData?.averageRating || 0}
      reviewCount={product.reviewMetaData?.count || 0}
      variant='emphasized'
      language={language}
      renderAction={
        product.reviewMetaData?.count && product.reviewMetaData?.count > 0
          ? content => (
              <>
                <TrackImmediate
                  trigger={
                    isInMediaGallery
                      ? showMediaGalleryReviewsTrigger()
                      : showOrderBlockReviewsTrigger()
                  }
                />
                <Link
                  href={`#${reviewsSectionId}`}
                  onClick={event => {
                    if (product.reviewMetaData?.count) {
                      scrollToTarget(reviewsSectionId)(event);
                      trackEvent(
                        isInMediaGallery
                          ? readMediaGalleryReviewsTrigger({
                              item_id: product.id
                            })
                          : readOrderBlockReviewsTrigger({
                              item_id: product.id
                            })
                      );
                    }
                  }}
                >
                  {content}
                </Link>
              </>
            )
          : undefined
      }
    />
  );
};
